export default "__VITE_ASSET__Cl_T_s8J__$_?format=webp__"